import { EMPTY_FILTER_VALUE } from 'Core/constants'
import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import { LocationByPeriodFilterFields, LocationByPeriods } from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getFiltersConfig = (): LocationByPeriods.Filter.Config => ({
	[LocationByPeriodFilterFields.serviceSiteId]: {
		label: i18n.t('pages:location.filters.label.serviceSiteId'),
		apiFilterFieldName: LocationByPeriodFilterFields.serviceSiteId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.serviceSiteId')
	},
	[LocationByPeriodFilterFields.kpiCategoryId]: {
		label: `${i18n.t('pages:location.filters.label.kpiCategoryId')}:`,
		apiFilterFieldName: LocationByPeriodFilterFields.kpiCategoryId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiCategoryId,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.kpiCategoryId')
	},
	[LocationByPeriodFilterFields.kpiId]: {
		label: `${i18n.t('pages:location.filters.label.kpiId')}:`,
		apiFilterFieldName: LocationByPeriodFilterFields.kpiId,
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.kpiId,
		defaultValue: null,
		placeholder: i18n.t('pages:location.filters.placeholder.kpiId')
	},
	[LocationByPeriodFilterFields.year]: {
		label: `${i18n.t('pages:location.filters.label.year')}:`,
		apiFilterFieldName: LocationByPeriodFilterFields.year,
		filterType: FilterTypes.VALUE,
		UrlParam: UrlParams.year,
		placeholder: i18n.t('pages:location.filters.placeholder.year'),
		defaultValue: '',
		emptyValue: EMPTY_FILTER_VALUE
	}
})
